import React from "react";
import "./style.scoped.scss";

type Props = {
  iconSrc: string;
  name: string;
};

function NavIcon({ iconSrc, name }: Props) {
  return (
    <div className="nav-icon">
      <div className="circle">
        <div className="icon">
          <img src={iconSrc} alt="nav icon" />
        </div>
        <div className="text">{name}</div>
      </div>
    </div>
  );
}
export { NavIcon as default };
